<template>
  <div class="form">
    <label
      ><strong
        >Folgende Zahlungsmethoden darf dieser Nutzer verwenden:</strong
      ></label
    >
    <ul class="list-group pb-3">
      <li class="list-group-item mb-0" v-if="paypal !== null">
        <toggle-switch
          label="PayPal"
          type="success"
          v-model="paypal"
        ></toggle-switch>
      </li>
      <li class="list-group-item mb-0" v-if="creditcard !== null">
        <toggle-switch
          label="Kreditkarte (Stripe)"
          type="success"
          v-model="creditcard"
        ></toggle-switch>
      </li>
      <li class="list-group-item mb-0" v-if="creditcard_micropayment !== null">
        <toggle-switch
          label="Kreditkarte (Micropayment)"
          type="success"
          v-model="creditcard_micropayment"
        ></toggle-switch>
      </li>
      <li class="list-group-item mb-0" v-if="klarna !== null">
        <toggle-switch
          label="Klarna"
          type="success"
          v-model="klarna"
        ></toggle-switch>
      </li>
      <li class="list-group-item mb-0" v-if="prepaid !== null">
        <toggle-switch
          label="Vorkasse"
          type="success"
          v-model="prepaid"
        ></toggle-switch>
      </li>
      <li class="list-group-item mb-0" v-if="paysafecard !== null">
        <toggle-switch
          label="Paysafecard"
          type="success"
          v-model="paysafecard"
        ></toggle-switch>
      </li>
      <li class="list-group-item mb-0" v-if="coupon !== null">
        <toggle-switch
          label="Gutschein"
          type="success"
          v-model="coupon"
        ></toggle-switch>
      </li>
      <li class="list-group-item mb-0" v-if="call2pay !== null">
        <toggle-switch
          label="Call2Pay"
          type="success"
          v-model="call2pay"
        ></toggle-switch>
      </li>
      <li class="list-group-item mb-0" v-if="handypay !== null">
        <toggle-switch
          label="HandyPay"
          type="success"
          v-model="handypay"
        ></toggle-switch>
      </li>
    </ul>
    <v-button
      :working="working"
      type="submit"
      class="btn btn-primary float-right"
      @click.native="persist()"
      >Änderung akzeptieren</v-button
    >
  </div>
</template>

<script>
export default {
  props: ["user"],
  data() {
    return {
      paypal: null,
      creditcard: null,
      creditcard_micropayment: null,
      klarna: null,
      prepaid: null,
      paysafecard: null,
      coupon: null,
      call2pay: null,
      handypay: null,
      working: false
    };
  },
  created() {
    Object.keys(this.user.allowed_payment_methods).forEach(key => {
      this.$data[key.split("-").join("_")] = this.user.allowed_payment_methods[
        key
      ];
    });
  },
  methods: {
    persist() {
      this.working = true;

      this.$http
        .patch(`/api/v1/user/${this.user.id}/update-payment-methods`, {
          paypal: this.paypal,
          creditcard: this.creditcard,
          creditcard_micropayment: this.creditcard_micropayment,
          klarna: this.klarna,
          prepaid: this.prepaid,
          paysafecard: this.paysafecard,
          coupon: this.coupon,
          call2pay: this.call2pay,
          handypay: this.handypay
        })
        .then(() => {
          this.$notify({
            title: "Die verwendbaren Bezahlmethoden wurden aktualisiert",
            type: "success"
          });
        })
        .finally(() => {
          this.working = false;
        });
    }
  }
};
</script>
